require('../../modules/es.object.values');

module.exports = require('../../internals/path').Object.values;
